var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"100vh","width":"100%","height":"100vh"},style:({
        backgroundImage: ("linear-gradient(" + _vm.degree + "deg, " + _vm.colors + " !important"),
    }),attrs:{"id":"scroll-target"}})}
var staticRenderFns = []

export { render, staticRenderFns }